<template>
	<!-- 客户应急保电订单详情 -->
	<div class="content">
		<div class="center">
			<div class="detail-top flex-row">
				<div class="title">当前状态：
<!--					{{statusName }}-->
            {{info.orderSatus == 0 ? '未确认提交': info.orderSatus == 1 ? '待厂商确认' : info.orderSatus == 2 ? '待平台签约'
							: info.orderSatus == 3 ? '待客户支付租金' : info.orderSatus == 4 ? '待厂商确认收款并发货'
									: info.orderSatus == 6 ? '待客户收货'
											: info.orderSatus == 7 ? '待厂商确认用电完成' : info.orderSatus == 11 ? '待客户确认用电完成'
													: info.orderSatus == 18 ? '待平台出具结算单' : info.orderSatus == 28 ? '待厂商结算'
															: info.orderSatus == 29 ? '待客户收款': info.orderSatus == 8 ? '已完成'
																	: info.orderSatus == 9 ? '已评价': info.orderSatus == 60 ? '待厂商确认续费'
																			: info.orderSatus == 70 ? '中止订单':'其他'
						}}{{(info.orderSatus==8||info.orderSatus==29||info.orderSatus==9)&&info.serviceFeeStatus==1?"(待收取服务费)":""}}
					{{info.orderSatus==7&&info.status!=60?"(可续费)":''}}
				</div>
				<el-button class="btn" plain v-if="status == 0" @click="deleteOrder">删除订单</el-button>
				<el-button class="btn" plain v-if="(status == 0 || status == 1 || status == 2 || status == 3)&&info.status!==60" @click="quxiaoOrder">中止订单</el-button>
				<el-button class="btn" plain v-if="status == 6&&info.status!==60" @click="songdian">确认收货</el-button>
				<el-button class="btn" plain v-if="status == 7 && info.xufeijg == null" @click="xufeiHandle">续费</el-button>
				<el-button class="btn" plain @click="$router.push({	path: '/service'})">联系客服</el-button>
			</div>
			<!-- 主要信息 -->
			<div class="card" v-for="(item, index) in info.equipmentList" :key="index">
				<div class="info-box">
					<el-image class="info-logo" :src="$imgUrl + item.pictureUrl" fit="cover"></el-image>
					<el-button class="btn msgBtn" plain @click="$router.push({
					path: '/service',
					query: {
						contactType: 1,
						contactId: info.customerId.id
					}
				})">在线留言</el-button>
					<div class="info-main">
						<div class="name">{{ item.title }}</div>
						<div class="price">价格<span class="num">￥{{ item.emergencyPrice }}/天</span></div>
						<p class="desc">*价格说明</p>
						<p class="desc">在勘查现场后，相关费用可能发生变化。</p>
						<div class="device-info">
							<div class="device-head">
								<p class="device-tit">设备信息</p>
							</div>
							<div class="device-list">
								<div class="device-item"><span class="item-tit">提供人姓名</span>{{ item.companyName }}</div>
								<div class="device-item"><span class="item-tit">设备类型</span>{{ item.typeName }}</div>
								<div class="device-item"><span class="item-tit">设备容量</span>{{ item.volume }}</div>
								<div class="device-item"><span class="item-tit">设备地点</span>{{ item.uprovinceName + item.ucityName +
										item.ucountyName + item.uaddress
								}}
								</div>
								<div class="device-item"><span class="item-tit">输出电压</span>{{ item.voltage }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 用电信息 -->
			<div class="card use-card" v-if="status != 0">
				<div class="card-tit">用电信息</div>
				<div class="list" :class="statusId == 4 ? 'bottom' : ''">
					<div class="item"><span class="item-tit">工程名称：</span>{{ info.projectname }}</div>
					<div class="item"><span class="item-tit">地址：</span>{{ info.userAddress }}</div>
					<div class="item"><span class="item-tit">服务天数：</span>{{ info.advanceDate }}天</div>
					<div class="item"><span class="item-tit">开始时间：</span> {{ info.startTime |formatDate }}</div>
					<div class="item"><span class="item-tit">结束时间：</span>{{ info.entTime |formatDate }}</div>
<!--					<div class="item"><span class="item-tit">平台签约时间：</span>{{ info.qrhtTime }}</div>-->
				</div>
			</div>


			<!-- 保电方案 -->
<!--			<div class="card file-card" v-if="scheme != null">-->
<!--				<div class="card-tit">保电方案</div>-->
<!--				<div class="file-box" style="margin-bottom: 20px;">-->
<!--					<img src="./bg.png" class="pdfIcon" alt="">-->
<!--				</div>-->
<!--				<div>-->
<!--					<span class="btn download" @click="xiazaifanan(item)" v-for="item in scheme.split(',')">下载</span>-->
<!--				</div>-->
<!--			</div>-->
			<!-- 附件合同签约 -->
<!--			<div class="card file-card" v-show="statusId > 2">-->
<!--				<div class="card-tit">附件合同签约</div>-->
<!--				<div class="file-warn">*可下载查看签约合同。</div>-->
<!--				<div class="file-box">-->
<!--					<img src="./bg.png" class="pdfIcon" alt="">-->
<!--					<div class="file-info">-->
<!--						<div class="file-name">应急保电设备合同<span class="type">（签约版）</span></div>-->
<!--						<div class="file-date">（{{ info.qrhtTime }}）</div>-->
<!--					</div>-->
<!--				</div>-->
<!--				<div class="btn download" @click="xiazai()">下载</div>-->
<!--			</div>-->
			<!-- 订单信息 -->
			<div class="card order-card" v-if="status > 0">
				<div class="card-tit">订单信息</div>
				<el-button class="btn detailBtn" plain @click="viewAccount">查看往来账目</el-button>
				<div class="list" :class="statusId == 4 ? 'bottom' : ''">
					<div class="item"><span class="item-tit">申请时间：</span>{{ info.addTime }}</div>
					<div class="item"><span class="item-tit">订单编号：</span>{{ info.orderNo }}</div>
					<div class="item"><span class="item-tit">平台技术服务费：</span>¥{{ info.serviceFee }}</div>
					<div class="item"><span class="item-tit">设备租金：</span>¥{{ info.advance }}</div>
					<div class="item"><span class="item-tit">预付油费：</span>¥{{ info.advanceFuel }}</div>
					<div class="item"><span class="item-tit">厂商确认时间：</span>{{ info.pttkkhTime }}</div>


					<template v-if="info.orderSatus!=70">
						<div class="item"><span class="item-tit">平台签约时间：</span>{{ info.qrhtTime }}</div>
					<div class="item"><span class="item-tit">用电用户支付租金及油费时间：</span>{{ info.khzfTime }}</div>
					<div class="item"><span class="item-tit">厂商确认收款租金及油费时间：</span>{{ info.csqrskTime }}</div>
					<div class="item"><span class="item-tit">发货时间：</span>{{ info.delivertime }}</div>
					<div class="item"><span class="item-tit">收货时间：</span>{{ info.taketime }}</div>
					<template v-if="info.status!=60">
					<div class="item"><span class="item-tit">厂商确认用电完成时间：</span>{{ info.factoryfinishtime }}</div>
					<div class="item"><span class="item-tit">客户确认用电完成时间：</span>{{ info.customfinishtime }}</div>
					<div class="item"><span class="item-tit">出具结算单时间：</span>{{ info.ptqrzjTime }}</div>
					<div class="item"><span class="item-tit">厂商退还租金及油费时间：</span>{{ info.settletime }}</div>
					<div class="item"><span class="item-tit">厂商支付平台（技术）服务费时间：</span>{{ info.cszffufTime }}</div>
					<div class="item"><span class="item-tit">平台确认平台（技术）服务费时间：</span>{{ info.ptqrsxfTime }}</div>
					<div class="item"><span class="item-tit">用户确认收款租金及油费时间：</span>{{ info.khqrskTime }}</div>
					</template>
					</template>

					<div class="item"><span class="item-tit" v-if="info.orderSatus==70">订单中止时间：</span>{{ info.zzddTime }}</div>



<!--					<div class="item"><span class="item-tit">申请时间：</span>{{ order.addTime }}</div>-->
<!--					<div class="item"><span class="item-tit">用电用户支付租金及油费时间：</span>{{ order.payTime }}</div>-->
<!--					<div class="item"><span class="item-tit">平台确认租金及油费时间：</span>{{ order.confirmTime }}</div>s-->
<!--					<div class="item"><span class="item-tit">订单编号：</span>{{ order.series }}</div>-->
<!--					<div class="item"><span class="item-tit">厂商支付平台（技术）服务费时间：</span>{{ order.payServiceTime }}</div>-->
<!--					<div class="item"><span class="item-tit">平台确认平台（技术）服务费时间：</span>{{ order.confirmServiceTime }}</div>-->
<!--					<div class="item"><span class="item-tit">平台技术服务费：</span>￥{{ info.serviceFee }}</div>-->
<!--					<div class="item"><span class="item-tit">发货时间：</span>{{ order.deliverTime }}</div>-->
<!--					<div class="item"><span class="item-tit">收货时间：</span>{{ order.takeTime }}</div>-->
<!--					<div class="item"><span class="item-tit">设备租金：</span>￥{{ info.advance }}</div>-->
<!--					<div class="item"><span class="item-tit">厂商确认用电完成时间：</span>{{ order.factoryfinishtime }}</div>-->
<!--					<div class="item"><span class="item-tit">客户确认用电完成时间：</span>{{ order.customfinishtime }}</div>-->
<!--					<div class="item"><span class="item-tit">预付油费：</span>￥{{ info.advanceFuel }} </div>-->
<!--					&lt;!&ndash; <div class="item"><span class="item-tit">平台退款客户租金及油费时间：</span></div>-->
<!--					<div class="item"><span class="item-tit">客户退款收款租金及油费时间：</span></div> &ndash;&gt;-->
<!--					<div class="item"><span class="item-tit">平台结款厂商租金及油费时间：</span>{{ order.settletime }}</div>-->
<!--					<div class="item"><span class="item-tit">厂商确认收款租金及油费时间：</span>{{ order.receivetime }}</div>-->

				</div>
				<!-- 续费 -->
				<div v-if="info.status == 60 || status == 60">
					<div class="card-tit">续费信息</div>
					<div class="list">
						<div class="item"><span class="item-tit">续费时间：</span>{{ info.xftime }}</div>
						<div class="item"><span class="item-tit">续费时长：</span>{{ info.xfday }}</div>
						<div class="item"><span class="item-tit">续费原因：</span>{{ info.xfyuanyin }}</div>
						<div class="item"><span class="item-tit">续费价格：</span>¥{{ info.xufeijg }}</div>
						<div class="item"><span class="item-tit">预付油费：</span>¥{{ info.xfyoufei }}</div>
						<div class="item"><span class="item-tit">平台技术服务费：</span>¥{{ info.xfptfwfy }}</div>

						<div class="item"><span class="item-tit">续费申请通过时间：</span>{{ info.csqrtysqTime }}</div>
						<div class="item"><span class="item-tit">用电用户支付租金及油费时间：</span>{{ info.xfkhzftime }}</div>
						<div class="item"><span class="item-tit">厂商确认收款租金及油费时间：</span>{{ info.xfcsqrsktime }}</div>
<!--						<div class="item"><span class="item-tit">发货时间：</span>{{ info.xffahuotime }}</div>-->
<!--						<div class="item"><span class="item-tit">收货时间：</span>{{ info.xfshouhuotime }}</div>-->
						<div class="item"><span class="item-tit">厂商确认用电完成时间：</span>{{ info.xfcsqrwctime }}</div>
						<div class="item"><span class="item-tit">客户确认用电完成时间：</span>{{ info.xfkhqrwctime }}</div>
						<div class="item"><span class="item-tit">出具结算单时间：</span>{{ info.xfptqrzjtime }}</div>
						<div class="item"><span class="item-tit">厂商退还租金及油费时间：</span>{{ info.xfptjkcstime }}</div>
						<div class="item"><span class="item-tit">厂商支付平台（技术）服务费时间：</span>{{ info.xfcszffwftime }}</div>
						<div class="item"><span class="item-tit">平台确认平台（技术）服务费时间：</span>{{ info.xfptqrfwftime }}</div>
						<div class="item"><span class="item-tit">客户确认收款租金及油费时间：</span>{{ info.xfkhqrsztime }}</div>

					</div>
				</div>

			</div>
			<!-- 支付信息 -->
<!--			<div class="card file-card" v-if="status > 3 && status != 13">-->
<!--				<div class="card-tit">支付信息</div>-->
<!--				<div class="file-warn">*订单完成后7天支付给厂家费用，按照实际用电时间退还油费。</div>-->
<!--				<div class="pay-box">-->
<!--					<div class="pay-item" v-for="(item, index) in voucherList" :key="index">-->
<!--						<el-image :src="$imgUrl + item.storageAdd" class="fileImg"-->
<!--							:preview-src-list="[$imgUrl + item.storageAdd]" />-->
<!--						<p class="pay-tit">{{ item.voucherDesc }}</p>-->
<!--						<p class="pay-desc">{{ item.voucherSource }}</p>-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->
			<!-- 上传支付信息 -->
			<div class="card file-card" v-show="status == 3">
				<div class="card-tit">支付信息</div>
<!--				<div class="file-warn">*请选择以下支付方式，支付完成后需要上传支付凭证后待审核通过后完成支付。</div>-->
<!--				<div class="choose-box">-->
<!--					&lt;!&ndash; 以下使用图片为 占位 图片 &ndash;&gt;-->
<!--					<div class="choose-item">-->
<!--						<el-image style="border: 1px solid #c5c5c5;" :src="require('../../assets/image/zhifubao.jpg')"-->
<!--							class="chooseImg" :preview-src-list="[require('../../assets/image/zhifubao.jpg')]" />-->
<!--						<p class="choose-tit">支付宝</p>-->
<!--					</div>-->
<!--					<div class="choose-item">-->
<!--						<el-image style="border: 1px solid #c5c5c5;" :src="require('../../assets/image/weixin.jpg')"-->
<!--							class="chooseImg" :preview-src-list="[require('../../assets/image/weixin.jpg')]" />-->
<!--						<p class="choose-tit">微信</p>-->
<!--					</div>-->
<!--					<div-->
<!--						style="display: flex;flex-direction: column;width: 500px;justify-content: space-between;font-size: 16px;">-->
<!--						<span>帐户信息</span>-->
<!--						<span>收款单位：石家庄思凯电力建设有限公司供用电四分公司</span>-->
<!--						<span>地 址：石家庄高新区中山东路1009号</span>-->
<!--						<span>电 话：0311-66662607</span>-->
<!--						<span>开户银行：中国工商银行石家庄长安支行 </span>-->
<!--						<span>账 号：0402 0204 1930 0189 157</span>-->
<!--					</div>-->
<!--				</div>-->
<!--				<div class="file-warn">*请把以上支付凭证上传至此,包含油费和设备租赁费用。</div>-->
<!--				<el-upload style="padding: 20px;" :multiple="false" :action="$uploadUrl" list-type="picture-card"-->
<!--					:on-success="handleAvatarSuccess" :on-remove="handleRemove" :accept="$imgExt">-->
<!--					<i class="el-icon-plus"></i>-->
<!--				</el-upload>-->
				<div class="btnGroup">
					<div class="btn scoreBtn" @click="uploadPaySuccess" v-if="status == 3">确认付款</div>
					<div class="btn cancelBtn" @click="$router.go(-1)">取消</div>
				</div>
			</div>
			<!-- 上传收款凭证 -->

			<div class="sure-time" v-if="status == 11 || status == 18 || status == 28 || status == 8||status == 28||status == 29||status == 8||status == 9">
				<div class="item-box" style="background-color: white"><p class="title">实际用电时间</p>
					<el-button v-if="status == 28||status == 29||status == 8||status == 9" style="float: right;" plain @click="viewJsDan">查看结算单</el-button></div>


				<div class="item-box">
					<div style="display: flex;padding: 20px 0;align-items: center;height: 150px;">
						<div class="" style="">
							<span>实际租用时间：{{ info.actualUseTime }}天</span>
							<span style="margin-left: 20px;">实际发电时间:{{ info.actualUse }}小时</span>
						</div>
						<div class="" style="display: flex;width: 800px;flex-wrap: wrap;margin-left: 100px;justify-content: space-between;line-height: 30px;">
							<span style="color: red;width: 200px;">客户已付租金：￥{{ info.xftkcszj }}</span>
							<span style="color: red;width: 200px;">客户实际租金：￥{{ info.xftkyhzj }}</span>
							<span style="color: red;width: 200px;">退还客户租金：￥{{ info.xftkzj }}</span>
							<span style="color: red;width: 200px;">结算平台服务费：￥{{ info.yonghufy }}</span>
							<span style="color: red;width: 200px;">客户已付油费：￥{{ info.xftkcsyf }}</span>
							<span style="color: red;width: 200px;">客户实际油费：￥{{ info.xftkyhyf }}</span>
							<span style="color: red;width: 200px;">退还客户油费：￥{{ info.xftkyf }}</span>
							<span style="color: red;width: 200px;"></span>
						</div>
					</div>
<!--					<div class="item">-->
<!--						<span>实际租用时间: <a>{{ info.actualUseTime }}天</a></span>-->
<!--					</div>-->
<!--					<div class="item">-->
<!--						<span>实际发电时间: <a>{{ info.actualUse }}小时</a></span>-->
<!--					</div>-->
<!--					<div class="item">-->
<!--						<div class="a">-->
<!--							<span >客户已付租金：￥{{ info.xftkcszj }}</span>-->
<!--							<span >客户实际租金：￥{{ info.xftkyhzj }}</span>-->
<!--							<span >退还客户租金：￥{{ info.xftkzj }}</span>-->
<!--							<span >结算平台服务费：￥{{ info.yonghufy }}</span>-->
<!--							<span >客户已付油费：￥{{ info.xftkcsyf }}</span>-->
<!--							<span >客户实际油费：￥{{ info.xftkyhyf }}</span>-->
<!--							<span >退还客户油费：￥{{ info.xftkyf }}</span>-->
<!--							<span ></span>-->
<!--&lt;!&ndash;							<span>退还客户租金：￥{{ info.thkhzj }}</span>&ndash;&gt;-->
<!--&lt;!&ndash;							<span>退还客户油费：￥{{ info.thkhyf }}</span>&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;							<span>结算厂家租金：￥{{ info.jscjzj }}</span>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;							<span>结算平台服务费：￥{{ info.wfwf }}</span>&ndash;&gt;-->

<!--						</div>-->
<!--&lt;!&ndash;						<div class="a">&ndash;&gt;-->
<!--&lt;!&ndash;							&ndash;&gt;-->
<!--&lt;!&ndash;							<span></span>&ndash;&gt;-->
<!--&lt;!&ndash;						</div>&ndash;&gt;-->
<!--					</div>-->
				</div>
				<div style="display: flex;padding: 0 20px;" v-if="status == 11">
					<div class="btn download" style="background-color: orange;color: #fff;" @click="wancheng()">确认完成
					</div>
					<div class="btn download" style="margin-left: 20px;" @click="backHandle">退回</div>
				</div>

			</div>
			<div class="card file-card" v-show="statusId == 29">
				<!--				<div class="file-warn">*请上传收款凭证111</div>-->
				<!--				<el-upload style="padding: 20px;" :multiple="false" :action="$uploadUrl" list-type="picture-card"-->
				<!--					:on-success="handleAvatarSuccess" :on-remove="handleRemove" :accept="$imgExt">-->
				<!--					<i class="el-icon-plus"></i>-->
				<!--				</el-upload>-->
				<div class="btnGroup">
					<div class="btn scoreBtn" @click="uploadPaySuccessOrther">确认收款</div>
				</div>
			</div>
			<!-- 评价 -->
			<div class="card file-card" v-if="statusId == 8">
				<div class="card-tit">评价</div>
				<div class="evaluate-box">
					<img :src="$imgUrl + info.heading" class="userImg" alt="">
					<el-input type="textarea" resize="none" :rows="4" placeholder="请输入内容" v-model="pjneirong">
					</el-input>
					<div class="upload-box">
						<p class="upload-add">图片上传</p>
						<el-upload :action="$uploadUrl" :multiple="false" list-type="picture-card" :on-success="handleCertSuccess1"
							:on-remove="handleRemove1" :accept="$imgExt">
							<i class="el-icon-plus"></i>
						</el-upload>
					</div>
					<div class="score-box">
						<div class="score-tit">综合评分</div>
						<div class="score-line">
							<el-rate v-model="value1"></el-rate>
						</div>
					</div>
					<div class="btn scoreBtn" @click="pingjia()" style="cursor: pointer;">评价</div>
				</div>
			</div>
			<!-- 评价列表 -->
			<div class="card file-card" v-show="status == 9">
				<div class="card-tit borderB">评价</div>
				<div class="evaluate-lists">
					<div class="evaluate-box evaluate-item" style="display: flex;flex-direction: column;"
						v-for="item in pinglunList" :key="item.id">
						<div class="user-line items-center">
							<img :src="$imgUrl + item.heading" class="userImg" alt="">
							<div class="user-name">{{ item.masterName }}</div>
							<div class="score-line" style="margin: 0 30px;">
								<el-rate v-model="item.fractionUser" disabled show-score text-color="#ff9900" score-template="">
								</el-rate>
							</div>
							<div class="user-name time">{{ item.updateTime }}</div>
						</div>
						<div class="evaluate" style="margin: 20px 0;">{{ item.proposal }}</div>
						<div class="imgs" v-if="item.proposalUrl">
							<el-image :src="$imgUrl + item1" class="evaluate-img" style="margin-right: 20px;" alt=""
								v-for="item1 in item.proposalUrl.split(',')" :preview-src-list="[$imgUrl + item1]" :key="item1">
							</el-image>
						</div>
					</div>
				</div>
			</div>
			<div class="card file-card" v-show="status == 9 && info.reply == 2">
				<div class="card-tit borderB">回复内容</div>
				<div style="background-color: #ebebeb;min-height: 30px;padding: 10px;margin: 0 20px;">
					{{ info.estimate }}
				</div>
				<div class="imgs evaluate-box evaluate-item" v-if="info.factoryPingJiaImg">
					<el-image :src="$imgUrl + item" class="evaluate-img" style="margin-right: 20px;" alt=""
						v-for="(item, index) in info.factoryPingJiaImg.split(',')" :preview-src-list="[$imgUrl + item]" :key="index">
					</el-image>
				</div>
			</div>

			<!-- 待提交申请 -->
			<div class="order" v-if="status == 0">
				<div class="order-info">
					<div class="top flex-row">
              <div class="item address-box">
                  <p class="tit1">*工程名称</p>
                  <div class="address flex-row" style="margin-bottom: 70px">
                      <el-input v-model="projectname"
                                placeholder="请填写工程名称"
                               >

                      </el-input>
                  </div>
              </div>

						<div class="item address-box">
							<p class="tit1">地址信息</p>
							<div class="address flex-row">
								<el-select v-model="addressVal" size="medium" style="width: 300px">
									<el-option v-for="(item, index) in addressList" :key="item.id"
										:label="item.provinceName + '-' + item.cityName + '-' + item.countyName + ' ' + item.address"
										:value="item.provinceName + item.cityName + item.countyName + item.address">
									</el-option>

								</el-select>
							</div>
						</div>
						<div class="item service-item">
							<p class="tit2">服务天数</p>
							<div class=" flex-row" style="padding-top: 15px;">
								<el-input placeholder="请输入天数" v-model="form.advanceDate" style="width: 100%;">
									<template slot="prepend">时长</template>
									<template slot="append">天</template>
								</el-input>
							</div>
						</div>
						<div class="item date-item">
							<div class="cont flex-row">
								<p>*开始时间：</p>
								<el-date-picker class="datetime" v-model="form.startTime" value-format="yyyy-MM-dd" type="date"
									placeholder="选择日期">
								</el-date-picker>
							</div>
							<p class="tips">*结束时间为次日开始时间的日期</p>
						</div>
					</div>
					<div class="pre-pay">
						<p class="tit3">油费预付</p>
						<div class="cont flex-row">
							<span>油费价格：</span>
							<span>￥{{ oilCost }}</span>
							<span>/小时</span>
						</div>
						<p class="tips">*设备油费单独收费，不包含在设备租赁费中，您需要预支付每天10小时的油费价格，多退少补。</p>
					</div>
				</div>
				<div class="bot flex-row">
					<el-button size="medium" type="info" @click="tijiao(1)">提交申请</el-button>
<!--					<el-button size="medium" type="info" @click="tijiao(2)">删除订单</el-button>-->
					<!-- <el-button size="medium" type="info" @click="changeEq">修改设备</el-button> -->
				</div>
			</div>
			<!-- 已完成 - 续费 -->
			<div class="card file-card renew-card" v-if="xufeiFlag">
				<div class="card-tit">续费信息</div>
				<div class="renew-box">
					<div class="num-box">
						<div class="num-tit">续费天数<span class="num-one">续费价格按照原价计算价格</span></div>
						<el-input placeholder="请输入内容" v-model="renewVal">
							<template slot="prepend">时长：</template>
							<template slot="append">/天</template>
						</el-input>
						<div class="num-tit">油费预付<span class="num-one">续费价格按照原价计算价格</span></div>
						<el-input placeholder="请输入内容" v-model="oilCost" readonly>
							<template slot="prepend">油费单价：</template>
							<template slot="append">/小时</template>
						</el-input>
						<div class="file-warn">*设备油费单独收费，不包含在设备租赁费中，您需要预支付每天10小时的油费价格，多退少补。</div>
					</div>
					<div class="num-box">
						<div class="num-tit">续费原因<span class="num-one">（可不填）</span></div>
						<el-input type="textarea" resize="none" :rows="4" placeholder="填写原因" v-model="textarea">
						</el-input>
					</div>
				</div>
				<div class="btnGroup">
					<div class="btn cancelBtn" @click="xufeishenqing()">提交</div>
					<div class="btn cancelBtn" @click="xufeiFlag = false">取消</div>
				</div>
			</div>
		</div>
		<account-dialog ref="accountDialogRef"></account-dialog>
<!--		<js-dan></js-dan>-->
		<js-dan ref="jsDanRef"></js-dan>
	</div>
</template>

<script>
import AccountDialog from './accountList.vue'
import axios from "axios";
import {
	orderDetailApi,
	adderssList,
	orderDelApi, updateElectOrder
} from '../../http/api/ordinary.js'
import {
	equOrderDetail,
	updateOrder,
	delOrder,
	addVoucherAllApi
} from '../../http/factory/add-eme.js';
import serverConfig from "@/http/config";
import JsDan from "@/view/orderDetail/jsDan.vue";
export default {
	name: 'orderDetailDevice',
	components: {
		JsDan,
		AccountDialog
	},
	data() {
		return {
        projectname:null,
			xufeiFlag: false,
			form: {
				startTime: '',
				advanceDate: 0,
				entTime: ""
			},
			addressVal: '',
			addressList: [],
			fileList: [],
			value1: null,
			statusId: 1,
			textarea: '',
			// 续费
			renewVal: 10,
			renewIndex: 0,
			orderId: "",
			title: "",
			price: "",
			userName: "",
			typeName: "",
			voltage: "",
			volume: "",
			address: "",
			xbxl: "",
			dlxl: "",
			jkxl: "",
			dgxl: "",
			uaddress: "",
			startTime: "",
			entTime: "",
			order: {
				applyTime: '2022/6/191',
				payTime: '2022/6/192',
				confirmTime: '2022/6/193',
				confirmContract: '2022/6/194',
				payServiceTime: '2022/6/195',
				confirmServiceTime: '2022/6/196',
				series: '2022/6/197',
				installTime: '2022/6/198',
				powerTime: '2022/6/199',
				rent: '2000',
				settleTime: '2022/6/19t',
				receiveTime: '2022/6/19f',
				renew: {
					applyTime: '2022/6/19',
					payTime: '2022/6/19',
					confirmTime: '2022/6/19',
					limit: '2022/6/19',
					payServiceTime: '2022/6/19',
					confirmServiceTime: '2022/6/19',
					price: '',
					settleTime: '2022/6/19',
					receiveTime: '2022/6/19'
				},
				suspend: {
					applyTime: '2022/6/19',
					reason: '2022/6/19',
					confirmTime: '2022/6/19'
				}
			},
			imageUrl: [],
			pjneirong: "",
			pjtp: "",
			duration: "",
			pinglunList: [],
			status: "",
			statusName: "",
			bdStatus: "",
			scheme: "",
			totalMoney: "",
			oilCost: "",
			advanceFuel: "",
			voucherList: [],
			accountList: [],
			htUrl: "",
			info: {

			}
		}
	},
	filters: {
		formatDate(date1) {
			let date = new Date(date1)
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			const hour = String(date.getHours()).padStart(2, '0');
			const minute = String(date.getMinutes()).padStart(2, '0');

			// 格式化为 'YYYY-MM-DD HH:mm' 的形式
			return `${year}-${month}-${day}`;
		}
	},
	created() {
		this.orderId = this.$route.query.id;
		// this.info.factoryPingJiaImg.length
		this.getDetail()
		if (this.status == 0) {
			adderssList({}).then(res => {
				this.addressList = res.rows;
			})
		}
	},
	methods: {
		viewJsDan() {
			this.$refs.jsDanRef.showDialog(this.info.jsDanVos)
		},
		xufeiHandle() {
			this.xufeiFlag = true
			window.scrollTo(0, 10000)
		},
		changeEq() {
			let obj = {
				id: this.info.businessId,
				name: this.info.companyName,
				heading: this.info.pictureUrl
			}
			this.$router.push({
				path: '/ordinaryUser/companyEme',
				query: {
					object: JSON.stringify(obj),
					serviceType: 1,
					changeEq: this.orderId
				}
			})
		},
		deleteOrder(){
			this.$confirm('你确定要删除当前订单吗', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {

				delOrder({
					id: this.orderId,
				}).then((res) => {
					this.$message({
						message: "删除成功",
						type: "warning",
						onClose: () => {
							this.$router.back();
						},
					});
				});



			})
		},
		quxiaoOrder() {
			this.$confirm('你确定要取消当前订单吗', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				updateOrder({
					id: this.orderId,
					orderSatus: 70,
					zzddTime: this.formatTime(),
				}).then(res => {
					this.$message({
						type: 'success',
						message: '中止成功'
					})
					this.$router.go(-1)
				})
			})
		},
		dateChange() {
			let date = new Date(this.form.startTime);
			date = date.getFullYear() + '-'
				+ (date.getMonth() + 1) + '-'   // 这里加1是因为getMonth()的返回值是为0~11
				+ date.getDate() + ' '
				+ date.getHours() + ':'
				+ date.getMinutes() + ':'
				+ date.getSeconds();
			date = Date.parse(new Date(date)) / 1000; // 转换成时间戳，返回值是ms，除1000后转化成秒
			date += (86400) * (this.form.advanceDate-1); // 一天是86400秒
			let newDate = new Date(parseInt(date) * 1000); // 把时间戳转换成日期
			let y = newDate.getFullYear();
			let MM = newDate.getMonth() + 1;
			MM = MM < 10 ? ('0' + MM) : MM;
			let d = newDate.getDate();
			d = d < 10 ? ('0' + d) : d;
			let h = newDate.getHours();
			h = h < 10 ? ('0' + h) : h;
			let m = newDate.getMinutes();
			m = m < 10 ? ('0' + m) : m;
			let s = newDate.getSeconds();
			s = s < 10 ? ('0' + s) : s;
			return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
		},
		tijiao(type) {
        if (this.projectname == null) {
            return this.$message('请填写工程名称')
        }
        if (this.form.startTime == null) {
            return this.$message('请选择开始时间')
        }
			if (type == 1) {
//申请时间
// 				console.log(this.info.advance);
// 				console.log(this.info.advanceFuel);
// 				console.log(this.info.serviceFee);
// 				console.log(parseFloat(this.info.advance / this.info.serviceFee / 100).toFixed(2));
// 				console.log(this.form);
// 				console.log(this.orderId);
// 				console.log(this.form.startTime);
// 				console.log(this.addressVal);
// 				console.log(this.dateChange());
				let price = 0;
				let price2 = 0;
				let price3 = 0;
				this.info.equipmentList.forEach(value => {
					price += (value.emergencyPrice * this.form.advanceDate);
					price2 = (this.oilCost * 10 * this.form.advanceDate)
				})
				console.log(price);
				console.log(price2);
				console.log(price * ((this.info.advance / this.info.serviceFee / 100).toFixed(2)));

				this.$confirm('你确定要申请当前订单吗', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					updateElectOrder({
						id: this.orderId,
						advance: price,
						advance_fuel: price2,
						user_address: this.addressVal,
              projectname: this.projectname,
						advance_date: this.form.advanceDate,
						order_satus: 1,
						start_time: this.form.startTime,
						ent_time: this.dateChange(),
						addTime:this.formatTime()
					}).then(res=>{
						// console.log(response.data);
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.$router.go(-1)
					})
				})


				// });
				return;

			}
			if (type == 2) {
				this.quxiaoOrder()
			}
			if (type == 3) {
				//修改订单
				updateOrder({
					id: this.orderId,
					orderSatus: 0,
					startTime: this.form.startTime,
					advanceDate: this.form.advanceDate
				}).then(res => {
					this.$message({
						message: '操作成功',
						type: 'success'
					});
					this.$router.go(-1)
				})
			}
		},
		zhongzhi() {
			updateOrder({
				id: this.orderId,
				orderSatus: 13
			}).then(res => {
				this.$message({
					message: '终止订单成功',
					type: 'success'
				});
				this.getDetail()
			})
		},
		backHandle() {
			this.$confirm('你确定要退回当前订单的用电信息吗', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				updateOrder({
					id: this.orderId,
					orderSatus: 7
				}).then(res => {
					this.$message({
						message: '退回成功',
						type: 'success'
					});
					this.$router.go(-1)
				})
			})
		},
		xufeishenqing() {
			this.$confirm('你确定提交当前订单的续费信息吗', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				updateOrder({
					id: this.orderId,
					orderSatus: 60,
					status: 1,
					xfyuanyin: this.textarea,
					// xftime: new Date(),
					xftime: this.formatTime(),
					xfday: this.renewVal,
				}).then(res => {
					this.$message({
						message: '续费申请成功',
						type: 'success'
					});
					this.$router.go(-1)
				})
			})
		},
		pingjia() {
			if (this.fileList.length <= 0) {
				this.$message({
					message: '请上传评价图片',
					type: 'warning'
				});
				return
			}
			// console.log(this.fileList);
			// return
			if (this.pjneirong == "") {
				this.$message({
					message: '请填写评价内容',
					type: 'warning'
				});
				return
			}
			if (this.value1 == 0) {
				this.$message({
					message: '请选择评分',
					type: 'warning'
				});
				return
			}
			updateOrder({
				id: this.orderId,
				proposalUrl: this.fileList.join(','),
				proposal: this.pjneirong,
				fractionUser: this.value1,
				orderSatus: 9
			}).then(res => {
				this.$message({
					message: '评价成功',
					type: 'success'
				});
				this.getDetail()
			})
		},
		handlePictureCardPreview1(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
		handleCertSuccess1(res, file) {
			if (res.code == 200) {
				this.fileList.push(res.fileName);
			}
		},
		handleRemove1(e, fileList) {
			console.log(e, fileList);
			console.log("删除", e.response.fileName);
			console.log("shanchju", this.fileList);
			var a = this.fileList.indexOf(e.response.fileName)
			if (a > -1) {
				this.fileList.splice(a, 1)
				console.log("卡", this.fileList);
			}
		},
		songdian() {
			if (this.info.status == 60) {
				this.$confirm('你确定要收到当前订单的设备了吗', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					updateOrder({
						id: this.orderId,
						orderSatus: 7,
						orderType: 1,
						xfshouhuotime: this.formatTime(),
					}).then(res => {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.$router.go(-1)
					})
				})
			} else {
				this.$confirm('你确定要收到当前订单的设备了吗', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					updateOrder({
						id: this.orderId,
						orderSatus: 7,
						taketime: this.formatTime(),
					}).then(res => {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.$router.go(-1)
					})
				})
			}
		},
		//确认用电宛城
		wancheng() {
			if (this.info.status == 60) {
				this.$confirm('你确定要当前订单的实际用电时间吗', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					updateOrder({
						id: this.orderId,
						orderSatus: 18,
						// xfkhqrwctime: new Date(),
						xfkhqrwctime: this.formatTime(),
					}).then(res => {
						this.$message({
							message: '确认完成成功',
							type: 'success'
						});
						this.$router.go(-1)
					})
				})
			} else {
				this.$confirm('你确定要当前订单的实际用电时间吗', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					updateOrder({
						id: this.orderId,
						orderSatus: 18,
						// customfinishtime: new Date(),
						customfinishtime: this.formatTime(),
					}).then(res => {
						this.$message({
							message: '确认完成成功',
							type: 'success'
						});
						this.$router.go(-1)
					})
				})
			}
		},
		handleAvatarSuccess(file) {
			this.imageUrl.push(file.fileName)
		},
		handleRemove(e, fileList) {
			console.log(e, fileList);
			console.log("删除", e.response.fileName);
			console.log("shanchju", this.imageUrl);
			var a = this.imageUrl.indexOf(e.response.fileName)
			if (a > -1) {
				this.imageUrl.splice(a, 1)
				console.log("卡", this.imageUrl);
			}
		},
		beforeAvatarUpload() {

		},
		//未付款提交支付凭证，确认支付租金和油费
		uploadPaySuccess() {

			if (this.info.status == 60) {
				this.$confirm('你确定要当前订单已经支付租金和油费了吗', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					updateOrder({
						id: this.orderId,
						orderSatus: 4,
						xfkhzftime: this.formatTime(),
					}).then(res => {
						this.$message({
							message: '确认付款成功',
							type: 'success'
						});
						this.$router.go(-1)
					})
				})
			} else {
				this.$confirm('你确定要当前订单已经支付租金和油费了吗', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					updateOrder({
						id: this.orderId,
						orderSatus: 4,
						khzfTime: this.formatTime(),
					}).then(res => {
						this.$message({
							message: '确认付款成功',
							type: 'success'
						});
						this.$router.go(-1)
					})
				})
			}
		},
		uploadPaySuccessOrther() {
			let obj = {
				id: this.orderId,
				ktype:4
			}
			if (this.info.status == 60) {
				obj['status'] = 60
				obj['ktype']=4
				obj['xfkhqrsztime'] = this.formatTime()
			} else {
				// obj['customconfirmtime'] = new Date()
				// khqrskTime
				obj['khqrskTime'] = this.formatTime()
			}
			if (this.info.equipmentModel == null || this.info.equipmentModel == '') {
				obj['equipmentModel'] = 1
			} else {
				obj['equipmentModel'] = 1
				obj['orderSatus'] = 8
			}
			this.$confirm('你确定要当前订单收到退款了吗', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				updateOrder(obj).then(res => {
					this.$message({
						message: '确认收款成功',
						type: 'success'
					});
					this.$router.go(-1)
				})
			})
		},
		xiazai() {
			window.open(this.htUrl)
		},
		xiazaifanan(va) {
			window.open(this.$imgUrl + va)
		},
		getDetail() {
			orderDetailApi({
				id: this.orderId
			}).then(res => {
				var thst = this
				this.info = res
				console.log(this.info.equipmentList)
				this.info.equipmentList = JSON.parse(this.info.equipmentList)
				console.log(this.info.equipmentList)
				this.info.equipmentList.forEach(function (item) {
					// console.log(item.oilCost);
					thst.oilCost += item.oilCost
				})
				this.addressVal = res.provinceName + res.cityName + res.countyName + res.uaddress
				this.addressVal = res.userAddress
          this.projectname = res.projectname
				this.form.advanceDate = res.advanceDate
				this.form.startTime = res.startTime

				this.htUrl = this.$imgUrl + res.htUrl
				this.accountList = res.accountsList

				this.voucherList = res.voucherList
				this.statusId = res.orderSatus
				this.status = res.orderSatus
				// if (res.orderSatus == 0) {
				// 	this.statusName = "待提交申请"
				// }
				// if (res.orderSatus == 1) {
				// 	this.statusName = "待确认"
				// }
				// if (res.orderSatus == 2) {
				// 	this.statusName = "待签约"
				// }
				// if (res.orderSatus == 3) {
				// 	this.statusName = "待支付租金"
				// }
				// if (res.orderSatus == 4) {
				// 	this.statusName = "已支付（待平台确认租金）"
				// }
				// if (res.orderSatus == 24) {
				// 	this.statusName = "待支付服务费"
				// }
				// if (res.orderSatus == 34) {
				// 	this.statusName = "服务费已支付（待平台确认）"
				// }
				// if (res.orderSatus == 5) {
				// 	this.statusName = "待发货"
				// }
				// if (res.orderSatus == 6) {
				// 	this.statusName = "待收货"
				// }
				// if (res.orderSatus == 7) {
				// 	this.statusName = "已收货"
				// }
				// if (res.orderSatus == 11) {
				// 	this.statusName = "待确认用电完成"
				// }
				// if (res.orderSatus == 18) {
				// 	this.statusName = "待结算"
				// }
				// if (res.orderSatus == 28 && res.equipmentModel != 1) {
				// 	this.statusName = "已结算（待确认收款）"
				// }
				// if (res.orderSatus == 8 || (res.orderSatus == 28 && res.equipmentModel == 1)) {
				// 	this.statusName = "已完成"
				// }
				// if (res.orderSatus == 9) {
				// 	this.statusName = "已评价"
				// }
				// if (res.orderSatus == 60) {
				// 	this.statusName = "续费申请"
				// }
				this.title = res.title
				this.price = res.emergencyPrice
				this.totalMoney = res.advance
				this.userName = res.bdName
				this.typeName = res.typeName
				this.voltage = res.voltage
				this.volume = res.volume
				this.bdStatus = res.bdStatus
				this.duration = res.advanceDate
				this.startTime = res.startTime
				this.entTime = res.entTime
				this.scheme = res.bdscheme
				this.order.addTime = res.addTime
				this.order.payTime = res.khzfTime
				this.order.confirmTime = res.ptqrzjTime
				this.order.confirmContract = res.qrhtTime
				this.order.payServiceTime = res.cszffufTime
				this.order.confirmServiceTime = res.ptqrsxfTime
				this.order.series = res.orderNo
				this.order.installTime = res.azysTime
				this.order.powerTime = res.gateTime
				this.order.deliverTime = res.delivertime
				this.order.takeTime = res.taketime
				this.order.factoryfinishtime = res.factoryfinishtime
				this.order.customfinishtime = res.customfinishtime
				this.order.settletime = res.settletime
				this.order.receivetime = res.receivetime
				// this.oilCost = res.oilCost
				this.advanceFuel = res.advanceFuel
				this.order.rent = res.advance
				this.order.settleTime = res.ptjscsTime
				this.order.receiveTime = res.csqrszTime
				this.pinglunList = res.emergencyPowerProtectionOrders
			})
		},
		viewAccount() {
			this.$refs.accountDialogRef.showDialog(this.accountList)
		}
	}
}
</script>

<style lang="less" scoped>
.content {
	background: #F5F5F5;

	.daiqueren-list {
		padding: 20px 30px;
		line-height: 40px;
		font-size: 15px;
		color: #737373;

		.span {
			color: #000;
		}
	}

	.btn {
		min-width: .96rem;
		background: #FFFFFF;
		border-radius: .06rem;
		font-size: .14rem;
		padding: .1rem .2rem;
		text-align: center;
		line-height: .2rem;
		color: #686868;
		border: 1px solid rgba(104, 104, 104, 0.19);
		cursor: pointer;
	}

	.sure-time {
		background-color: #fff;
		padding-bottom: 20px;

		.title {
			font-size: 25px;
			padding: 20px 20px 0;
			font-weight: bold;
			color: #000;
			width: 100%;
		}

		.item-box {
			padding: 10px 0;
			background-color: #eefff0;
			border-radius: 10px;
			display: flex;
			margin: 10px 20px;

			.item {
				margin: 20px 10px;
				font-size: 15px;
				display: flex;
				color: #535353;
				height: 60px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				line-height: 20px;

				span {
					margin: 0px 40px;
				}

				a {
					color: red;
				}

				.a {
					color: red;
					margin: 10px 0;

				}
			}
		}

	}

	.center {
		width: 15.2rem;
		margin: 0 auto;
		padding: .1rem 0 .4rem;

		.detail-top {
			width: 100%;
			height: .82rem;
			background: #FFFFFF;
			border-radius: .1rem;
			margin-bottom: .1rem;
			padding: 0 .3rem 0 .2rem;
			box-sizing: border-box;
			align-items: center;

			.title {
				font-size: .18rem;
				font-weight: bold;
				color: #F6812F;
				flex: 1;
			}
		}

		.card {
			background: #FFF;
			border-radius: .06rem;
			margin-bottom: .1rem;

			.card-content {
				color: #727272;
				font-size: .14rem;
				padding: 0 .33rem .25rem;
				box-sizing: border-box;
			}

			// 实际用电时间
			&.card-use {
				padding-bottom: .2rem;

				.card-time {
					width: 14.55rem;
					height: .74rem;
					margin: 0 auto;
					background: #FFFCF9;
					display: flex;
					align-items: center;

					.time-item {
						font-size: .14rem;
						color: #FF4F4F;
						padding: .075rem .24rem;

						.label {
							color: #979797;
						}

						.days {
							color: #000;
						}
					}

					.card-back {
						padding-left: 1rem;
						padding-right: 0rem;
					}
				}
			}

			.card-tit {
				padding: .22rem .33rem;
				font-weight: bold;
				font-size: .18rem;
				color: #000000;
			}

			.btnGroup {
				display: flex;
				padding: .4rem 0 .18rem;
				justify-content: center;

				.btn {
					width: 1.38rem;
					background: #686868;
					border-radius: .09rem;
					text-align: center;
					font-size: .14rem;
					color: #FFFFFF;
					padding: .1rem 0;
					line-height: .2rem;
				}

				.cancelBtn {
					background: #FFFFFF;
					border: 1px solid #686868;
					margin-left: .38rem;
					color: #686868;
					cursor: pointer;
				}
			}

			&.renew-card {
				.btnGroup {
					justify-content: flex-end;
					padding-right: .4rem;
				}
			}

			.list {
				font-size: 0;
				border-bottom: 1px solid #E6E6E6;
				padding-bottom: .15rem;

				&.bottom {
					border: unset;
					padding-top: .22rem;
				}

				.item {
					padding: 0 .07rem 0 .35rem;
					font-size: .14rem;
					color: #000;
					display: inline-block;
					padding-bottom: .22rem;

					&.tit {
						font-weight: bold;
					}

					.item-tit {
						color: #8E8E8E;
					}
				}
			}

			// 选择支付
			.choose-box {
				padding: .2rem 0;
				width: 14.59rem;
				margin: 0 auto .1rem;
				box-sizing: border-box;
				display: flex;
				border-bottom: 1px solid #E6E6E6;

				.choose-item {
					font-size: 0;
					margin-right: 1.32rem;
					display: inline-block;

					.chooseImg {
						width: 1.44rem;
						height: 2rem;
					}

					.choose-tit {
						padding-top: .1rem;
						font-size: .13rem;
						color: #000000;
						text-align: center;
					}
				}
			}

			.choose-uploader {
				width: 1.44rem;
				height: 1.44rem;
				background: #F8F8F8;
				border-radius: .08rem;
				border: 1px solid #CFD3DA;
				margin-left: .33rem;
				font-size: .14rem;
				color: #363636;
				text-align: center;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;

				.uplodImg {
					width: .36rem;
					height: .36rem;
				}

				.add {
					font-size: .13rem;
					margin-top: .14rem;
				}
			}

			// 评价
			.evaluate-box {
				padding: .2rem .3rem 1rem;
				box-sizing: border-box;
				display: flex;
				position: relative;

				.userImg {
					width: .44rem;
					height: .44rem;
					border-radius: 50%;
					margin: 0 .3rem 0 .1rem;
				}

				/deep/ .el-textarea {
					height: 1.53rem;
					width: 4rem;
				}

				/deep/ .el-textarea__inner {
					background: #F6F6F6;
					border: 1px solid #F6F6F6;
					font-size: .14rem;
					height: 1.53rem;
				}

				.upload-box {
					width: 4rem;
					margin: 0 .16rem;
					background: #FFFFFF;
					border-radius: .06rem;
					border: 1px solid #EEEEEE;
					padding: .12rem .14rem;
					box-sizing: border-box;

					.upload-add {
						font-size: .14rem;
						color: #8F8F8F;
						margin-bottom: .1rem;
					}

					.avatar-uploader {
						width: .73rem;
						height: .73rem;
						background: #EFEFEF;
						border-radius: .06rem;
						font-size: .13rem;
						text-align: center;
						padding-top: .24rem;
						box-sizing: border-box;
						color: #727272;
					}

					/deep/ .el-upload--picture-card {
						background-color: #fbfdff;
						border: 1px dashed #c0ccda;
						border-radius: 6px;
						box-sizing: border-box;
						width: 100px;
						height: 100px;
						cursor: pointer;
						line-height: 100px;
						vertical-align: top;
					}

					/deep/ .el-upload-list__item {
						width: 100px;
						height: 100px;
					}
				}

				.score-box {
					flex: 1;
					padding-left: 1rem;
					box-sizing: border-box;
					font-size: 0;

					.score-tit {
						font-size: .16rem;
						color: #000000;
						padding-bottom: .24rem;
					}

					.score-line {
						img {
							width: .3rem;
							height: .3rem;
							margin-right: .2rem;
						}
					}
				}

				.scoreBtn {
					width: 1.38rem;
					background: #686868;
					border-radius: .09rem;
					position: absolute;
					bottom: 0rem;
					right: .44rem;
					text-align: center;
					font-size: .14rem;
					color: #FFFFFF;
					padding: .1rem 0;
					line-height: .2rem;
				}
			}

			// 申请终止
			&.stopCard {
				.evaluate-box {
					padding-bottom: 0rem;
					padding-top: 0rem;

					/deep/ .el-textarea {
						width: 100%;
					}
				}

				.scoreBtn {
					position: unset;
				}
			}

			// 订单信息
			&.order-card {
				position: relative;

				.detailBtn {
					position: absolute;
					right: .33rem;
					top: .13rem;
				}

				.list {
					border-top: 1px solid #E9E9E9;
					border-bottom: unset;
					padding: .2rem .33rem .1rem;
					box-sizing: border-box;

					.item {
						width: 33%;
						padding-left: 0;
						box-sizing: border-box;

						&.tit {
							display: block;
						}

						&.line {
							display: block;
						}

						&.price {
							font-size: .12rem;
							color: #A0A0A0;

							.num {
								color: #FF5858;
							}

							.item-tit {
								color: #979797;
							}
						}
					}

					.item-tit {
						color: #8D8D8D;
					}
				}
			}

			.file-warn {
				padding: 20px;
				font-size: .13rem;
				color: #FF7878;
			}

			&.file-card {
				margin-top: 10px;
				padding-bottom: .22rem;

				.file-box {
					padding: 0 .33rem;
					box-sizing: border-box;
					display: flex;
					align-items: center;

					.pdfIcon {
						width: .44rem;
						height: .48rem;
						margin-right: .05rem;
					}

					.file-name {
						font-size: .13rem;
						color: #000000;
						padding-bottom: .12rem;
						padding-left: .08rem;

						.type {
							color: #FF6332;
						}
					}

					.file-date {
						font-size: .13rem;
						color: #BDBDBD;
					}
				}

				.download {
					min-width: .6rem;
					width: .6rem;
					margin: .2rem .33rem 0;
					background: #FFFFFF;
					border-radius: .04rem;
					color: #FF7531;
					font-size: .13rem;
					border: 1px solid rgba(255, 84, 0, 0.15);
				}
			}

			// 支付信息
			.pay-box {
				padding: 0 .2rem;
				box-sizing: border-box;
				font-size: 0;

				.pay-item {
					padding-bottom: .2rem;
					width: 1.6rem;
					text-align: center;
					display: inline-block;

					.pay-tit {
						padding: .12rem 0 .08rem;
						font-size: .13rem;
						color: #333333;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
					}

					.pay-desc {
						font-size: .13rem;
						color: #989898;
					}
				}

				.fileImg {
					width: 1.33rem;
					height: 1.33rem;
					margin: 0 auto;
				}
			}

			.info-box {
				padding: .67rem .33rem .1rem;
				box-sizing: border-box;
				display: flex;
				align-items: flex-start;
				position: relative;

				.msgBtn {
					position: absolute;
					right: .3rem;
					top: .6rem;
					color: #FA6600;
					border: 1px solid #FA6600;
				}

				.info-logo {
					width: 2.96rem;
					height: 2.96rem;
					margin-right: .2rem;
				}

				.info-main {
					.name {
						width: 6.2rem;
						font-size: .2rem;
						font-weight: bold;
						color: #333333;
						line-height: .23rem;
						padding-left: .1rem;
					}

					.price {
						line-height: .25rem;
						font-size: .14rem;
						color: #000000;
						padding: .19rem .1rem .12rem;

						.num {
							font-size: .18rem;
							font-weight: bold;
							color: #FF4141;
							padding-left: .2rem;
						}
					}

					.desc {
						padding-left: .1rem;
						padding-bottom: .1rem;
						font-size: .13rem;
						font-weight: 400;
						color: #8F8F8F;
					}

					.device-info {
						width: 100%;
						border-radius: .06rem;
						border: 1px solid #F2F2F2;
						margin-top: .16rem;
						padding-bottom: .2rem;

						.device-head {
							width: 100%;
							background: #FFF3EC;
							border-radius: .03rem;
							border: 1px solid #FFEBDF;
							font-size: .16rem;
							color: #000;
							padding: .15rem .14rem;
							box-sizing: border-box;

							.device-tit {
								line-height: .14rem;
								border-left: .04rem solid #FF5400;
								padding: 0 .1rem;
								font-weight: bold;
								color: #000000;
							}
						}

						.device-list {
							font-size: 0;

							.device-item {
								width: 50%;
								font-size: .14rem;
								font-weight: 400;
								color: #333333;
								padding: .2rem 0 0;
								display: inline-block;

								.item-tit {
									width: 1.4rem;
									text-align: right;
									padding-right: .14rem;
									font-size: .14rem;
									color: #AAAAAA;
									display: inline-block;
								}
							}
						}
					}
				}
			}

			// 方案内容
			.info-pro {
				padding: .1rem .24rem .26rem .37rem;

				.pro-tit {
					font-weight: bold;
					font-size: .16rem;
					color: #000;
				}

				.pro-box {
					background: #F9F9F9;
					margin: .26rem 0 0 .05rem;
					min-height: .96rem;
					background: #F9F9F9;
					border-radius: .06rem;
					padding: .1rem;
					box-sizing: border-box;
					font-size: 0;

					.pro-item {
						width: 20%;
						display: inline-block;
						font-size: .14rem;
						padding: .1rem;
						box-sizing: border-box;
						color: #333;

						.item-tit {
							padding-right: .12rem;
							color: #727272;
						}
					}
				}
			}
		}
	}
}

// 续费信息
.renew-box {
	padding: .10rem .33rem .2rem;
	font-size: 0;
	display: flex;

	.num-box {
		&:last-child {
			flex: 1;

			/deep/ .el-textarea {
				height: 2.3rem;
			}

			/deep/ .el-textarea__inner {
				background: #F6F6F6;
				border: 1px solid #F6F6F6;
				font-size: .14rem;
				height: 2rem;
			}
		}

		.num-tit {
			font-size: .14rem;
			color: #474747;
			padding-bottom: .12rem;

			&:nth-child(3) {
				padding-top: .48rem;
			}

			.num-one {
				color: #9D9D9D;
				padding-left: .1rem;
			}
		}

		.file-warn {
			padding-left: 0 !important;
		}

		/deep/ .el-input {
			margin-bottom: .1rem;
			max-width: 3.8rem;
		}

		/deep/ .el-input__inner {
			background: #FAFAFA;
			padding: .1rem .08rem;
			line-height: .2rem;
			height: auto;
			text-align: center;
			color: #000;
			font-size: .14rem;
			// border-radius: .04rem;
			border: 1px solid #EDEDED;
			border-left: unset;
			border-right: unset;
		}

		/deep/ .el-input-group__append,
		/deep/ .el-input-group__prepend {
			border: 1px solid #EDEDED;
			border-right: unset;
			background: #FAFAFA;
			font-size: .14rem;
			color: #000;
		}

		/deep/ .el-input-group__append {
			border: 1px solid #EDEDED;
			border-left: unset;
		}
	}
}

/* 待支付订单 */
.order {
	margin-top: .1rem;
	background: #FFFFFF;
	border-radius: .06rem;
	padding: .3rem 0 0;

	.order-info {
		padding: 0 .3rem;

		.top {
			.address-box {
				margin-right: 1.7rem;

				.tit1 {
					font-size: .16rem;
					color: #000000;
					line-height: .2rem;
				}

				.address {

					padding-top: .15rem;
					position: relative;

					.address-info {
						flex: 1;
						padding-right: 1.1rem;

						p {
							font-size: .14rem;
							color: #333333;
							line-height: 1.2;
						}

						p:nth-of-type(2) {
							margin-top: .1rem;
							font-size: .14rem;
							color: #5F5F5F;
							line-height: 1.2;
						}
					}

					button {
						width: .93rem;
						height: .3rem;
						background: #FF5400;
						border-radius: .03rem;
						font-size: .12rem;
						color: #FFFFFF;
						line-height: .3rem;
						border: none;
						position: absolute;
						right: .17rem;
						bottom: .18rem;
					}
				}
			}

			.service-item {
				margin-right: .69rem;

				.tit2 {
					font-size: .16rem;
					color: #000000;
					line-height: .2rem;
				}

				.cont {
					margin-top: .12rem;
					width: 3.33rem;
					height: .43rem;
					background: #F5F5F5;
					border-radius: .06rem;
					justify-content: space-between;
					padding: 0 .14rem;

					span {
						font-size: .14rem;
						line-height: .43rem;
					}
				}
			}

			.date-item {
				.cont {
					margin-top: .32rem;
					width: 3.33rem;
					height: .43rem;
					background: #F5F5F5;
					border-radius: .06rem;
					justify-content: space-between;
					padding: 0 .14rem;
					align-items: center;

					p {
						white-space: nowrap;
						line-height: .43rem;
					}

					.date {
						border-radius: .06rem;

						/deep/.el-input {
							flex: 1;
						}

						/deep/.el-input__inner {
							width: 100%;
							height: .43rem;
							background: #F5F5F5;
							padding-left: 0;
							font-size: .14rem;
							color: #000000;
							border: none;
							text-align: center;
						}

						/deep/.el-input__prefix {
							left: unset;
							right: 0;
						}

						/deep/.el-input__icon {
							line-height: .43rem;
						}
					}
				}
			}
		}

		.pre-pay {
			margin-top: .55rem;

			.tit3 {
				font-size: .16rem;
				color: #000000;
				line-height: .2rem;
			}

			.cont {
				margin-top: .12rem;
				width: 3.33rem;
				height: .43rem;
				background: #F5F5F5;
				border-radius: .06rem;
				justify-content: space-between;
				padding: 0 .14rem;

				span {
					font-size: .14rem;
					line-height: .43rem;
				}
			}
		}

		.tips {
			font-size: .13rem;
			color: #FF7575;
			margin-top: .1rem;
			line-height: .2rem;
		}
	}

	.bot {
		margin-top: .4rem;
		width: calc(100% - .6rem);
		padding: .22rem .3rem .22rem;
		justify-content: flex-end;

		.apply {
			width: 1.38rem;
			height: .4rem;
			background: #686868;
			border: 1px solid #686868;
			border-radius: .09rem;
			font-size: .14rem;
			color: #FFFFFF;
			line-height: .4rem;
			text-align: center;
			margin-left: .35rem;
		}

		.saveOrder {
			width: 1.38rem;
			height: .4rem;
			border: 1px solid #686868;
			border-radius: .09rem;
			font-size: .14rem;
			color: #686868;
			line-height: .4rem;
			text-align: center;
			margin-left: .32rem;
		}
	}
}

.evaluate-img {
	width: 120px;
	height: 120px;
}
</style>
